<template>
  <div class="card mb-6">
    <div class="card-content">
      <table class="table is-fullwidth">
        <tr>
          <th style="width: 30%">
            Wifi Id
          </th>
          <td>
            {{ $props.vendor.id }}
          </td>
        </tr>
        <tr>
          <th>
            Name
          </th>
          <td>
            {{ $props.vendor.name }}
          </td>
        </tr>
        <tr>
          <th>
            Description
          </th>
          <td style="word-break: break-word;">
            {{ $props.vendor.description }}
          </td>
        </tr>
        <tr>
          <th>
            Magazines count
          </th>
          <td>
            {{ $props.vendor.magazine.length }}
          </td>
        </tr>
        <tr>
          <th>
            Created at
          </th>
          <td>
            {{ $props.vendor.created_at }}
          </td>
        </tr>
        <tr>
          <th>
            Updated at
          </th>
          <td>
            {{ $props.vendor.updated_at }}
          </td>
        </tr>

      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vendor: {
      type: Object
    }
  }
}
</script>
